import { Button, Avatar } from 'antd'
import { getInitials } from '../../scheduleModel'

type Props = {
  crewLeadName: string
  crewLeadAvatar?: string
  onCancel: () => void
  onSave: () => void
  hasChanges: boolean
  isSaving: boolean
}

const ReorderDayViewTitleBar = ({ crewLeadName, crewLeadAvatar, onCancel, onSave, isSaving }: Props) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px 24px',
      backgroundColor: 'white',
      borderBottom: '1px solid #f0f0f0'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Avatar src={crewLeadAvatar} size={32}>
          {getInitials(crewLeadName)}
        </Avatar>
        <span style={{ fontSize: '14px' }}>
          You are reordering planned events for <strong>{crewLeadName}'s</strong> crew
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Button onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onSave}
          disabled={isSaving}
          loading={isSaving}
        >
          Save New Order
        </Button>
      </div>
    </div>
  )
}

export default ReorderDayViewTitleBar